<!-- 基础卡片 活动速报,推荐专题等-->
<template>
  <div class="base-card" v-if="cardInfor">
    <img :src="cardInfor.coverPhoto.url"/>
    <div class="topic-title" v-if="topic">
      <span>{{topic.see}} 看过</span>
      <span>{{topic.num}} 文章</span>
    </div>
    <div class="base-card-title">
      <span>{{cardInfor.title.substring(0, 18)}}</span>
      <span v-if="cardInfor.title.length > 18">{{cardInfor.title.substring(18)}}</span>
    </div>
  </div>
</template>
<script>
import baseCard from '@/assets/img/test/basecard.jpg'
export default {
  name: 'base-card',
  data () {
    return {
    }
  },
  props: ['topic','cardInfor']
}
</script>
<style lang="scss" scoped>
  .base-card {
    position: relative;
    width: 280px;
    height: 196px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    border-radius:6px;
    background: transparent;
    >img{
      border-top-left-radius:6px;
      border-top-right-radius:6px;
      width: 280px;
      height: 125px;
      border-top-left-radius:6px;
      border-top-right-radius:6px;
    }
    >.topic-title{
      position: absolute;
      bottom: 70px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #333333;
      background: rgba(255, 255, 255, 0.6);
      width: 100%;
      height: 26px;
      padding: 0 18px;
    }
    >.base-card-title {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      height: 72px;
      padding: 16px 0 16px 7px;
      text-align: left;
      border:1px solid rgba(234,234,234,1);
      border-top: none;
      border-bottom-left-radius:6px;
      border-bottom-right-radius:6px;
      background: #ffffff;
      >span{
        padding-left: 7px;
      }
      >:first-child {
        border-left: 4px solid #E70012;
      }
      >:nth-child(2) {
        padding-left: 11px;
      }
    }
    &:hover {
      box-shadow:0px 4px 16px 0px rgba(51,51,51,0.1);
    }
  }
</style>


